<template>
    <div :class="'alert alert-'+type" role="alert">
        <div>
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props:['type'],
    name: "AlertComponent",

    mounted() {

    }
}
</script>

<style scoped>

</style>
